import customHeaders, { getSpace } from '../../../common/headers'
import { ButtonClose } from '@lk-gtcom/ecomlab-components';
import { Loader } from '../../../common/components/Loader/Loader'
import { CarouselSlick } from '../../CarouselSlick/CarouselSlick'
import { ModalCardCreated } from '../ModalCardCreated/ModalCardCreated'
import { useState, useEffect } from 'react'
import { TitlePage } from '../../TitlePage/TitlePage';
import useGeneralStore from '../../../store/general'
import { ModalComponent } from '../ModalComponent/ModalComponent';
import './ModalProductPreview.scss'

const parse = require('html-react-parser')

const ModalProductPreview = ({ setIsModal, selectedCategories, currentProductId, isEdit = false, productTemporary }) => {
    const selectedSpace = useGeneralStore(state => state.selectedSpace)
    const headers = { ...customHeaders, ...getSpace(selectedSpace) }
    // const [productTemporary, setProductTemporary] = useState({})
    const [name, setName] = useState('')
    const [basic, setBasic] = useState([])
    const [basicPrice, setBasicPrice] = useState([])
    const [offerId, setOfferId] = useState([])
    const [description, setDescription] = useState([])
    const [required, setRequired] = useState([])
    const [additional, setAdditional] = useState([])
    const [media, setMedia] = useState([])

    const [loading, setLoading] = useState(false)
    const [isModalSuccessful, setIsModalSuccessful] = useState(false)

    useEffect(() => {
        // Basic
        let basicPrice = []
        setBasic(
            [...productTemporary?.basic?.filter(el => {
                const attr_id = el?.attribute_id
                if (attr_id === "name") {
                    setName(el)
                } else if (attr_id === "old_price" || attr_id === "price") {
                    basicPrice.push(el)
                } else if (attr_id === "offer_id") {
                    setOfferId(el)
                } else {
                    return el
                }
            })]
        )
        setBasicPrice(basicPrice)

        // Description
        setDescription(productTemporary?.description)

        // Required
        setRequired(productTemporary?.required)

        // Additional
        setAdditional(productTemporary?.additional)

        // Media
        const PTImages = productTemporary?.images?.value
        let images = PTImages?.length > 0 ? PTImages : []

        const PTVideos = productTemporary?.videos?.value
        let videos = PTVideos?.length > 0 ? PTVideos : []

        setMedia([...images, ...videos])

    }, [productTemporary, selectedSpace])


    return (
        <>
            {isModalSuccessful &&
                <ModalCardCreated
                    setIsModal={setIsModalSuccessful}
                />}

            <ModalComponent
                title={name?.value ? name?.value : 'Название не указано'}
                onClose={e => setIsModal(false)}
                loading={loading}
                child={
                    <div className='modal-product-preview'>
                        <>
                            <div className='breadcrumbs-and-article'>
                                {selectedCategories?.length > 0 &&
                                    <div className='category-breadcrumbs__content'>
                                        {selectedCategories?.map(l => <p className='category-breadcrumbs__item'
                                            key={l.value.id}>{l.label}</p>)}
                                    </div>}
                            </div>

                            <p className='text_article'>Артикул: <span>{offerId?.value ? offerId?.value : 'Отсутвует'}</span></p>


                            <div className='modal-product-preview__content'>
                                <div className='data-content'>
                                    <div className='slider-and-price'>
                                        <div className='img-content'>
                                            <CarouselSlick imgArr={media} />
                                        </div>

                                        <div className='price-box'>
                                            <div className='price-box_price'>
                                                <p className='text'>{basicPrice[0]?.value ? (parseInt(basicPrice[0]?.value)).toLocaleString() : 0} <span>₽</span></p>
                                            </div>
                                            <div className='price-box_old-price'>
                                                <p className='text_old-price'>Старая цена</p>
                                                <p className='text'>{basicPrice[1]?.value ? (parseInt(basicPrice[1]?.value)).toLocaleString() : 0} <span>₽</span></p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='characteristics-group'>
                                        <div className='description-content'>
                                            <TitlePage
                                                medium
                                                title='Общие данные'
                                            />
                                            <div className='description-content__item'>
                                                <div className='characteristics-items'>
                                                    {
                                                        basic?.map(el => {
                                                            const { front_name, value } = el
                                                            return (
                                                                <div className='characteristics-item' key={JSON.stringify(el)}>
                                                                    <p className='text_grey'>{front_name}</p>
                                                                    <div className='border'></div>
                                                                    <p className='text'>{value ? value : 'Отсутствует'}</p>
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                </div>
                                            </div>

                                            <TitlePage
                                                medium
                                                title='Обязательные характеристики'
                                            />
                                            <div className='description-content__item'>
                                                <div className='characteristics-items'>
                                                    {
                                                        required?.map(el => {
                                                            const { attribute_name, value } = el
                                                            return (
                                                                <div className='characteristics-item'>
                                                                    <p className='text_grey'>{attribute_name}</p>
                                                                    <div className='border'></div>
                                                                    <p className='text'>{value ? value : 'Отсутвует'}</p>
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                </div>
                                            </div>

                                            <TitlePage
                                                medium
                                                title='Описание'
                                            />
                                            <div className='description-content__item'>
                                                <p className='text_description'>{description?.value ? parse(description?.value) : 'Отсутвует'}</p>
                                            </div>

                                        </div>

                                        <div className='description-content'>
                                            <TitlePage
                                                medium
                                                title='Дополнительные характеристики'
                                            />
                                            <div className='characteristics-items'>
                                                {
                                                    additional?.map(el => {
                                                        let { attribute_name, attribute_id, value } = el

                                                        if (Array.isArray(value)) {
                                                            if (!value?.length > 0) {
                                                                value = ''
                                                            }
                                                        }

                                                        if (attribute_id === "22073") {
                                                            value = value ? 'Да' : 'Нет'
                                                        }

                                                        return (
                                                            <div className='characteristics-item'>
                                                                <p className='text_grey'>{attribute_name}</p>
                                                                <div className='border'></div>
                                                                <p className='text'>{value || value?.length > 0 ? value : 'Отсутвует'}</p>
                                                            </div>
                                                        )
                                                    })
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    </div >
                }
            />
        </>
    )
}

export { ModalProductPreview }